export const TAB_TIME		= 0;
export const TAB_PLACE		= 1;
export const TAB_SPECIES	= 2;
export const TAB_OTHER		= 3;
